$(document).ready(function () {
  $(document).on("click", ".collection-tag-swatch li", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    // Find the parent product card of the clicked button
    var productCard = $(this).closest(".product-block");
    var SwatchTitle = $(this).data("title");
    var SwatchSubtitle = $(this).data("subtitle");
    var SwatchUrl = $(this).data("url");
    var SwatchPrice = $(this).data("price");
    var SwatchFirstImage = $(this).data("featured-image");
    var SwatchSecondImage = $(this).data("featured-second-image");
    var SwatchReviews = $(this).data("reviews");
    productCard.find(".product-block__title").text(SwatchTitle);
    productCard.find(".product-subtitle").text(SwatchSubtitle);
    productCard
      .find(".product-price__item.product-price__amount")
      .text(SwatchPrice);
    productCard.find(".image-cont .product-link").attr("href", SwatchUrl);
    productCard.find(".product-info .product-link").attr("href", SwatchUrl);
    productCard
      .find(".image-label-wrap .product-block__image--active img")
      .attr("data-srcset", SwatchFirstImage);
    productCard
      .find(".image-label-wrap .product-block__image--active img")
      .attr("srcset", SwatchFirstImage);
    productCard
      .find(
        ".image-label-wrap .product-block__image--show-on-hover .rimage-background"
      )
      .attr("data-lazy-bgset-src", SwatchSecondImage);
    productCard
      .find(
        ".image-label-wrap .product-block__image--show-on-hover .rimage-background"
      )
      .attr("data-bgset", SwatchSecondImage);
    productCard
      .find(
        ".image-label-wrap .product-block__image--show-on-hover .rimage-background"
      )
      .css("background-image", "url(" + SwatchSecondImage + ")");
    productCard.find(".product-info .product-link").attr("href", SwatchUrl);
    productCard.find(".product-info .jdgm-widget").html(SwatchReviews);
  });
});

jQuery(document).ready(function ($) {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $(".header-sticky").addClass("sticky");
    } else {
      $(".header-sticky").removeClass("sticky");
    }
  });
  $(document).ready(function () {
    $(document).on("click", ".mobile_nav_icon-close", function () {
      $(".navbarResponsive2").removeClass("navbaropen");
    });
    $(document).on("click", ".mobile_nav_icon", function () {
      $(".navbarResponsive2").addClass("navbaropen");
    });
  });

  if (!qs('.template-product') && !(qs('.template-suffix-bundle-products'))) {
  AOS.init({
    offset: 120,
    duration: 1500,
    once: true,
  });
  window.addEventListener("load", AOS.refresh);
  }
});


$(document).ready(function () {
  $(".group1").colorbox({ rel: "group1" });
  $(".group2").colorbox({ rel: "group2", transition: "fade" });
  $(".group3").colorbox({
    rel: "group3",
    transition: "none",
    width: "75%",
    height: "75%",
  });
  $(".group4").colorbox({ rel: "group4", slideshow: true });
  $(".ajax").colorbox();
  $(".youtube").colorbox({ iframe: true, innerWidth: 640, innerHeight: 390 });
  $(".vimeo").colorbox({ iframe: true, innerWidth: 500, innerHeight: 409 });
  $(".iframe").colorbox({ iframe: true, width: "80%", height: "80%" });
  $(".inline").colorbox({ inline: true, width: "50%" });
  $(".callbacks").colorbox({
    onOpen: function () {
      alert("onOpen: colorbox is about to open");
    },
    onLoad: function () {
      alert("onLoad: colorbox has started to load the targeted content");
    },
    onComplete: function () {
      alert("onComplete: colorbox has displayed the loaded content");
    },
    onCleanup: function () {
      alert("onCleanup: colorbox has begun the close process");
    },
    onClosed: function () {
      alert("onClosed: colorbox has completely closed");
    },
  });

  $(".non-retina").colorbox({ rel: "group5", transition: "none" });
  $(".retina").colorbox({
    rel: "group5",
    transition: "none",
    retinaImage: true,
    retinaUrl: true,
  });

  $("#click").click(function () {
    $("#click")
      .css({ "background-color": "#f00", color: "#fff", cursor: "inherit" })
      .text("Open this window again and this message will still be here.");
    return false;
  });

  $("#mahina_flow_select").on("change", function () {
    $("#mahina_flow_val").html(this.value);
    $(".mahina_flow_url").prop(
      "href",
      $(this).children("option:selected").data("id")
    );
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateQuantity(action, fieldName) {
    var input = document.querySelector(`input[name="${fieldName}"]`);
    var currentValue = parseInt(input.value, 10);
    var minValue = parseInt(input.getAttribute("min"), 10) || 1;
    var maxValue = parseInt(input.getAttribute("max"), 10) || 10;

    if (action === "plus" && currentValue < maxValue) {
      input.value = currentValue + 1;
    } else if (action === "minus" && currentValue > minValue) {
      input.value = currentValue - 1;
    }
    $("#mahina_quantity").val(input.value);
  }
  document.querySelectorAll(".btnnumber").forEach(function (button) {
    button.addEventListener("click", function () {
      var type = this.getAttribute("data-type");
      var field = this.getAttribute("data-field");
      updateQuantity(type, field);
    });
  });
  if (document.getElementById("product-form")) {
    document.getElementById("product-form").addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent default form submission
      let parent = e.currentTarget;
      let size = parent.querySelector(".Size-is-your-option.active");
      let abs = parent.querySelector(".Absorbency-is-your-option.active");
      let atc = parent.querySelector("#add-to-cart-btn");
      let errEl = parent.querySelector(".selection-error-msg");
      errEl.classList.remove("show");

      // Check for errors in selection
      if (!size || !abs) {
        if (!size && !abs) {
          errEl.textContent = "Please Select The Size & Absorbency";
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "ATC_Variant_Selection_Error",
            ecommerce: {
              items: [
                {
                  item_id: atc.getAttribute('data-atc'),
                  item_name: atc.getAttribute("data-title"),
                  item_brand: atc.getAttribute("data-brand"),
                  item_category: atc.getAttribute("data-category"),
                  currency: atc.getAttribute("data-currency"),
                  price: atc.getAttribute("data-price"),
                },
              ],
            },
          });
        } else if (!size) {
          errEl.textContent = "Please Select Your Size";
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "ATC_Variant_Selection_Error",
            ecommerce: {
              items: [
                {
                  item_id: atc.getAttribute('data-atc'),
                  item_name: atc.getAttribute("data-title"),
                  item_brand: atc.getAttribute("data-brand"),
                  item_category: atc.getAttribute("data-category"),
                  currency: atc.getAttribute("data-currency"),
                  price: atc.getAttribute("data-price"),
                },
              ],
            },
          });
        } else if (!abs) {
          errEl.textContent = "Please Select The Absorbency";
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "ATC_Variant_Selection_Error",
            ecommerce: {
              items: [
                {
                  item_id: atc.getAttribute('data-atc'),
                  item_name: atc.getAttribute("data-title"),
                  item_brand: atc.getAttribute("data-brand"),
                  item_category: atc.getAttribute("data-category"),
                  currency: atc.getAttribute("data-currency"),
                  price: atc.getAttribute("data-price"),
                },
              ],
            },
          });
        }
        setTimeout(() => {
          errEl.classList.add("show");
        }, 100);

        // Return early to prevent the form submission and item addition
        return false;
      }

      // If no errors, proceed with adding to cart
      var formData = new FormData(this);
      var variantId = formData.get("id");
      var desktopQuantity = parseInt(document.querySelector('input[name="quant[1]"]').value) || 1;

      var finalQuantity = desktopQuantity;
      let preOrder = false;
      const buttonTextcheck = document.querySelector("#add-to-cart-btn #button-text").textContent;
      if (qs('.item-for-preorder') && buttonTextcheck == 'Pre-Order Now') {
        // preOrder = true;
      }
      // let additionalProperty = preOrder ? { 'Pre Order': 'true' } : {};
      // Add the item to the cart
      let propertiesData = {};
      if (document.referrer.includes("/collections/beyond-blood")) {
        propertiesData["Item added from"] = "BB LP New Ads";
      } else {
        propertiesData["Item added from"] = "Product Page";
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: finalQuantity,
              properties: propertiesData,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const buttonText = document.querySelector("#add-to-cart-btn #button-text");
          const addButton = document.querySelector("#add-to-cart-btn");

          const stickyAtcbuttonText = qs('.add__group.active-el #add-to-cart-btn #button-text');
          const stickyaddButton = document.querySelector(".add__group.active-el #add-to-cart-btn");

          if (buttonText) buttonText.textContent = "Adding";
          if (addButton) addButton.disabled = true;

          if (stickyAtcbuttonText) stickyAtcbuttonText.textContent = "Adding";
          if (stickyaddButton) stickyaddButton.disabled = true;
          setTimeout(() => {
            if (buttonText) buttonText.textContent = "Added";
            if (addButton) addButton.disabled = false;

            if (stickyAtcbuttonText) stickyAtcbuttonText.textContent = "Added";
            if (stickyaddButton) stickyaddButton.disabled = false;
            handleFloCartBtn();
          }, 2000);

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              items: [
                {
                  item_id: atc.getAttribute('data-atc'),
                  item_name: atc.getAttribute("data-title"),
                  item_brand: atc.getAttribute("data-brand"),
                  item_category: atc.getAttribute("data-category"),
                  item_variant: atc.getAttribute("data-sku"),
                  currency: atc.getAttribute("data-currency"),
                  price: atc.getAttribute("data-price"),
                },
              ],
            },
          });
          setTimeout(() => {
            if (preOrder) {
              buttonText.textContent = "Pre-Order Now";
              addButton.classList.add('gradient-card-2');
            }
            else{
              if (buttonText) buttonText.textContent = "Add To Cart";
              if (stickyAtcbuttonText) stickyAtcbuttonText.textContent = "Add To Cart";
              addButton.classList.remove('gradient-card-2');
            }
          }, 3000);
        })
        .catch((error) => {
          console.error("Error adding item to cart:", error);
        });
    });
  }



});

function updateContent(absorbencyLevel) {
  var content = "";
  switch (absorbencyLevel) {
    case "Light":
      content =
        'Absorbs <b>10ml</b> = 1 Sanitary Pad <i>|</i> Save Approx. <b>₹994</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
    case "Medium":
      content =
        'Absorbs <b>25ml</b> = 2.5 Sanitary Pads <i>|</i> Save Approx. <b>₹2981</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
    case "Heavy":
      content =
        'Absorbs <b>40ml</b> = 4 Sanitary Pads <i>|</i> Save Approx. <b>₹3974</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
    case "Super Heavy":
      content =
        'Absorbs <b>50ml</b> = 5 Sanitary Pads <i>|</i> Save Approx. <b>₹4968</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
    case "SuperHeavy":
      content =
        'Absorbs <b>50ml</b> = 5 Sanitary Pads <i>|</i> Save Approx. <b>₹4968</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
    default:
      content =
        'Absorbs <b>10ml</b> = 1 Sanitary Pad <i>|</i> Save Approx. <b>₹994</b> On Pads Annually <span class="tnc-hover">TnC</span>';
      break;
  }
  document.getElementById("absorbency-info") &&
    (document.getElementById("absorbency-info").innerHTML = content);

}


function itemAvailabilty() {
  const sizeVariantAvailabilty = document.querySelector(
    ".mahina_selector_1.active"
  );
  const absorbensyVariantAvailabilty = document.querySelector(
    ".mahina_selector_2.active"
  );
  const sizeVar = sizeVariantAvailabilty
    ? sizeVariantAvailabilty.getAttribute("data-availabilty")
    : "";
  const absorbensyVar = absorbensyVariantAvailabilty
    ? absorbensyVariantAvailabilty.getAttribute("data-availabilty")
    : "";

  const addtoCartButton = document.querySelector("#add-to-cart-btn");
  const addtoCartButtontext = document.querySelector(
    "#add-to-cart-btn #button-text"
  );
  if (sizeVar == "false") {
    addtoCartButton && (addtoCartButton.setAttribute("disabled", "disabled"));
    addtoCartButtontext && (addtoCartButtontext.textContent = "Sold Out");
  }
  if (absorbensyVar == "false") {
    addtoCartButton && (addtoCartButton.setAttribute("disabled", "disabled"));
    addtoCartButtontext && (addtoCartButtontext.textContent = "Sold Out");
    absorbensyVariantAvailabilty.classList.add("sold-out-button");
  }
}
document.addEventListener("DOMContentLoaded", function () {
  itemAvailabilty();
});

function togglePopup(event) {
  var popup = document.getElementById("tnc-popup");
  if (popup) {
    popup.classList.toggle("visible");
    // Stop the propagation to prevent document click handler from firing
    event.stopPropagation();
  }
}

function hidePopup() {
  var popup = document.getElementById("tnc-popup");
  if (popup) {
    popup.classList.remove("visible");
  }
}
function showQuestionPopup() {
  const questionHovers = document.querySelectorAll(".question-hover");
  const questionPopups = document.querySelectorAll(".question-popup");
  for (let i = 0; i < questionHovers.length; i++) {
    questionPopups[i].style.display = "none";
    questionHovers[i].addEventListener("click", function () {
      if (questionPopups[i].style.display === "none") {
        questionPopups[i].style.display = "block";
      } else {
        questionPopups[i].style.display = "none";
      }
    });
  }
}
showQuestionPopup();

document.addEventListener("DOMContentLoaded", function () {
  //Homepage tnc
  $(".card-tnc-click").click(function (event) {
    event.stopPropagation();
    var id = $(this).data("id");
    $(".card-tnc-popup")
      .not("#popup-" + id)
      .hide(); // Hide other popups
    $("#popup-" + id).toggle();
  });

  $(document).click(function () {
    $(".card-tnc-popup").hide();
  });

  // Hide the popup when clicking anywhere outside
  document.addEventListener("click", function (event) {
    var popup = document.getElementById("tnc-popup");
    if (
      popup &&
      popup.classList.contains("visible") &&
      !popup.contains(event.target)
    ) {
      hidePopup();
    }
  });
});
if (document.getElementById("buyNowButton")) {
  document
    .getElementById("buyNowButton")
    .addEventListener("click", function (e) {
      e.preventDefault();

      const variantSelector = document.querySelector("variant-selector2");

      if (
        variantSelector &&
        variantSelector.currentVariant &&
        variantSelector.currentVariant.id
      ) {
        let preOrder = false;
        if (qs('.item-for-preorder')) {
          // preOrder = true;
        }
        // let additionalProperty = preOrder ? { 'Pre Order': 'true' } : {};
        const variantId = variantSelector.currentVariant.id;
        const quantity =
          parseInt(document.querySelector('input[name="quant[1]"]').value) || 1;

        let propertiesData = {};
        if (document.referrer.includes("/collections/beyond-blood")) {
          propertiesData["Item added from"] = "Beyond Blood Product Page";
        } else {
          propertiesData["Item added from"] = "Product Page";
        }
        fetch("/cart/clear.js", { method: "POST" })
          .then(() => {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: quantity,
                  properties: propertiesData,
                }],
              }),
            });
          })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json();
          })
          .then((data) => {
            // Redirect to checkout
            window.location.href = "/checkout";
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      } else {
        console.error(
          "Variant ID is not available or variant-selector2 is not correctly initialized."
        );
      }
    });
}

$(document).ready(function () {
  updateCarousel("Medium"); // This will show the 'light' class on page load
});
function updateCarousel(absorbencyLevel) {
  // Hide all items first
  $(".pdp_sec8_mobile li").css("display", "none");

  // Normalize the className by replacing spaces and converting to lower case
  var className = absorbencyLevel.replace(/\s+/g, "_").toLowerCase(); // Replace spaces with underscores and convert to lowercase

  // Now, show the correct class with display flex
  $("." + className).css("display", "flex"); // Change display to 'flex'
}

// Track order js start
document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("track-by-tracking-id-form")) {
    if (window.innerWidth <= 768) {
      document.getElementById("track-by-tracking-id-form").style.display =
        "none";
      document.getElementById("tab-order-number").style.borderBottom =
        "3px solid #000";

      document
        .getElementById("tab-order-number")
        .addEventListener("click", function () {
          document.getElementById(
            "track-by-order-phone-email-form"
          ).style.display = "block";
          document.getElementById("track-by-tracking-id-form").style.display =
            "none";
          setActiveTab("tab-order-number");
        });

      document
        .getElementById("tab-track-number")
        .addEventListener("click", function () {
          document.getElementById(
            "track-by-order-phone-email-form"
          ).style.display = "none";
          document.getElementById("track-by-tracking-id-form").style.display =
            "block";
          setActiveTab("tab-track-number");
        });

      function setActiveTab(activeTabId) {
        document.getElementById("tab-order-number").style.borderBottom = "none";
        document.getElementById("tab-track-number").style.borderBottom = "none";

        document.getElementById(activeTabId).style.borderBottom =
          "3px solid #000";
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all divs intended for absorbency details
  document
    .querySelectorAll(".style-and-fit-detail, .absorption-detail, .wash-care")
    .forEach(function (element) {
      var text = element.textContent; // Get the text content of the element
      var items = text.split(";"); // Assume text content is semi-colon separated

      if (items.length > 1) {
        // Check if there are multiple items, otherwise do nothing
        var list = document.createElement("ul");
        items.forEach(function (item) {
          var listItem = document.createElement("li");
          listItem.textContent = item.trim();
          list.appendChild(listItem);
        });
        element.innerHTML = ""; // Clear the text content of the element
        element.appendChild(list); // Append the newly created list
      }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.href == "https://mahina.co/pages/know-your-flow?customer_posted=true" || window.location.href == "https://mahina.co/pages/know-your-flow?customer_posted=true#contact_form" || window.location.href == "https://mahina.co/pages/know-your-flow?form_type=customer#contact_form" || window.location.href == "https://mahina.co/pages/know-your-flow?form_type=customer") {
    window.location.href = "/collections/know-your-flow?view=flow";
  }
  attachEventListeners("tnc-hover", "click", togglePopup);
});

function attachEventListeners(className, eventType, eventHandler) {
  var elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++) {
    elements[i].removeEventListener(eventType, eventHandler);
    elements[i].addEventListener(eventType, eventHandler);
  }
}
